import React from 'react';
import {Field} from 'formik';
import {TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {Button, CircularProgress} from "@mui/material";
import {helper} from "../../../../utils/helper";
import {toastHelper} from "../../../../utils/toast-helper";
import {coordEnChaine} from "../agenceRules";

function AgenceDataField({values, errors, handleChange, handleBlur, setFieldValue}) {
    const [geocodage, setGeocodage] = React.useState(false);
    const geocoder = async () => {
        const adresse = (values.adresse || '').trim();
        if (!adresse) return;
        setGeocodage(true);
        try {
            const geo = await helper.geocodeAddress(adresse);
            setFieldValue('latitude', coordEnChaine(geo.latitude));
            setFieldValue('longitude', coordEnChaine(geo.longitude));
        } catch (e) {
            toastHelper.handleError(e, e?.message || "Échec du géocodage.");
        } finally {
            setGeocodage(false);
        }
    };
    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations Agence</Typography>
            </Grid>

            {/* LIBELLE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelle}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                autoFocus
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* CODE COULEUR */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Couleur <span className="asterix">*</span>
                </Grid>
                <Grid size={2}>
                    <Field type="color" value={values.codeCouleur}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.codeCouleur && form.touched.codeCouleur)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.codeCouleur}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="codeCouleur"
                                label="Couleur"
                                type="color"
                                slotProps={{
                                    input: {
                                        style: {height: "3rem", padding: 0, width: "5rem"}
                                    },
                                    inputLabel: {shrink: true}
                                }}
                                helperText={
                                    form.errors.codeCouleur &&
                                    form.touched.codeCouleur &&
                                    String(form.errors.codeCouleur)
                                }
                            />
                        )}
                    </Field>
                </Grid>
                <Grid size={4}>
                    <span style={{
                        display: 'inline-block',
                        backgroundColor: values.codeCouleur,
                        borderRadius: '4px',
                        padding: '4px 12px',
                        color: '#fff',
                        fontWeight: 'bold',
                        marginLeft: '1rem',
                        textShadow: '0 1px 2px rgba(0,0,0,0.4)'
                    }}>
                        {values.libelle || 'Aperçu'}
                    </span>
                </Grid>
            </Grid>

            {/* ADRESSE + COORDONNÉES (point de départ du simulateur de découpage) */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>Adresse</Grid>
                <Grid size={9}>
                    <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center'}}>
                        <TextField onChange={handleChange} onBlur={handleBlur} value={values.adresse}
                                   variant="outlined" margin="normal" size="small" fullWidth name="adresse" label="Adresse"/>
                        <Button color="primary" onClick={geocoder} disabled={geocodage || !(values.adresse || '').trim()}
                                startIcon={geocodage ? <CircularProgress size={22}/> : null}>
                            Géocoder
                        </Button>
                    </div>
                </Grid>
            </Grid>
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>Coordonnées</Grid>
                <Grid size={4.5}>
                    <TextField onChange={handleChange} onBlur={handleBlur} value={values.latitude}
                               error={Boolean(errors.latitude)} helperText={errors.latitude}
                               variant="outlined" margin="normal" size="small" fullWidth name="latitude" label="Latitude"/>
                </Grid>
                <Grid size={4.5}>
                    <TextField onChange={handleChange} onBlur={handleBlur} value={values.longitude}
                               error={Boolean(errors.longitude)} helperText={errors.longitude}
                               variant="outlined" margin="normal" size="small" fullWidth name="longitude" label="Longitude"/>
                </Grid>
                <Grid size={3}/>
                <Grid size={9}>
                    <Typography variant="caption">
                        Remplies par « Géocoder », modifiables à la main. Sans coordonnées, l'agence ne peut pas servir de base au simulateur.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default AgenceDataField;
